export { ImageCarousel } from "./image-carousel.component";
